import { decodeHTML } from 'entities';

export function decodeHtmlEntities(text: string | null | undefined): string {
  return text ? decodeHTML(text) : '';
}
